import Http from '@/services/Http';

const path = 'organizations/webhooks';
const webhooks = new Http(path);

webhooks.list = (params) =>
  webhooks.get('', '', `${params === undefined ? '' : `?${params}`}`);
webhooks.create = (payload) => webhooks.post(payload);
webhooks.remove = (id) => webhooks.delete(id);
webhooks.update = (id, payload) => webhooks.patch(id, payload);

export default webhooks;
